export const BREAK_XS = 550;
export const BREAK_S = 768;
export const BREAK_MED = 1024;
export const SITE_MAX_WIDTH = 1200;
export const SITE_HEIGHT_LARGE = 1200;

export const NOT_XS = `(min-width: ${BREAK_S + 1}px)`;
export const SCREEN_XXS = `(max-width: ${BREAK_XS}px)`;
export const SCREEN_XS = `(max-width: ${BREAK_S}px)`;
export const SCREEN_SM = `(max-width: ${BREAK_MED}px) and (min-width: ${
    BREAK_S + 1
}px)`;
export const SCREEN_MD = `(max-width: ${SITE_MAX_WIDTH}px) and (min-width: ${
    BREAK_MED + 1
}px)`;
export const SCREEN_LG = `(min-width: ${SITE_MAX_WIDTH}px)`;
